import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seoHead";
import { AdminRoute } from "@/components/auth/AdminRoute";
import AdminBrandDetail from "@/pages/admin/AdminBrandDetail";

export const Route = createFileRoute("/admin/lojas/$brandId")({
  head: () => seoHead({
    title: "Administração | Shopping do Bem",
    description: "Área administrativa do Shopping do Bem.",
    noindex: true,
  }),
  component: () => (
    <AdminRoute>
      <AdminBrandDetail />
    </AdminRoute>
  ),
});
